import i18n from "i18next";
import i18nBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { getCookie } from "./utils";

const language = getCookie("accept-language") || navigator.language || "en";

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    lng: language,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath:
        import.meta.env.MODE === "electron"
          ? "https://editor.riders.ai/v4/i18n/{{lng}}.json"
          : "/v4/i18n/{{lng}}.json",
    },
  });

export default i18n;
